import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Reveal } from '../hooks/useReveal';
import { assets } from '../mock';

const SectionTitle = ({ eyebrow, title, subtitle, light }) => (
  <div className="text-center max-w-2xl mx-auto">
    <div className="flex items-center justify-center gap-3 mb-4">
      <span className="h-px w-8 bg-[#e6b83f]/60" />
      <span className="font-sans-el text-[12px] tracking-[0.35em] uppercase text-[#e6b83f]">{eyebrow}</span>
      <span className="h-px w-8 bg-[#e6b83f]/60" />
    </div>
    <h2 className="font-deco text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#f7f1e3]">{title}</h2>
    {subtitle && <p className="font-serif-el italic text-lg sm:text-xl text-[#cdc6b5] mt-4">{subtitle}</p>}
  </div>
);

export { SectionTitle };

const About = () => {
  const { t } = useLanguage();
  return (
    <section id="about" className="section-pad bg-[#14120d]">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 border-t border-l border-[#e6b83f]/50" />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b border-r border-[#e6b83f]/50" />
              <img src={assets.aboutImage} alt="LAJO" className="w-full h-[460px] object-cover " />
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div>
              <div className="flex items-center gap-3 mb-4">
                <span className="h-px w-8 bg-[#e6b83f]/60" />
                <span className="font-sans-el text-[12px] tracking-[0.35em] uppercase text-[#e6b83f]">{t.about.eyebrow}</span>
              </div>
              <h2 className="font-deco text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#f7f1e3] leading-tight">
                {t.about.title}
              </h2>
              <p className="font-serif-el text-lg text-[#c8c1b2] mt-6 leading-relaxed">{t.about.p1}</p>
              <p className="font-serif-el text-lg text-[#c8c1b2] mt-4 leading-relaxed">{t.about.p2}</p>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-10 pt-8 border-t border-[#e6b83f]/15">
                {t.about.stats.map((s) => (
                  <div key={s.label}>
                    <div className="font-deco text-3xl sm:text-4xl gold-gradient-text font-bold">{s.value}</div>
                    <div className="font-sans-el text-[12px] tracking-[0.12em] uppercase text-[#b6af9d] mt-2">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
